export default () => ({
    show: false,
    loading: false,
    checkout: false,
    notice() {
        this.show = true;
        setTimeout(() => {
            this.show = false
        }, 6000)
    }
});